import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

import { userId, type UserId } from './User.js'

/** Identifier type for public.note_ */
export type NoteId = string & { __brand: 'NoteId' }

/** Represents the table public.note_ */
export default interface NoteTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<NoteId, NoteId | undefined, NoteId>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  createdBy: ColumnType<UserId | null, UserId | null, UserId | null>

  /** Database type: pg_catalog.timestamptz */
  updatedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  updatedBy: ColumnType<UserId | null, UserId | null, UserId | null>

  /** Database type: pg_catalog.timestamptz */
  deletedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  deletedBy: ColumnType<UserId | null, UserId | null, UserId | null>

  /** Database type: pg_catalog.text */
  message: ColumnType<string | null, string | null, string | null>
}

export type Note = Selectable<NoteTable>

export type NoteInitializer = Insertable<NoteTable>

export type NoteMutator = Updateable<NoteTable>

export const noteId = z.string() as unknown as z.Schema<NoteId>

export const note = z.object({
  id: noteId,
  createdAt: z.coerce.date().nullable().optional(),
  createdBy: userId.nullable().optional(),
  updatedAt: z.coerce.date().nullable().optional(),
  updatedBy: userId.nullable().optional(),
  deletedAt: z.coerce.date().nullable().optional(),
  deletedBy: userId.nullable().optional(),
  message: z.string().nullable().optional(),
}) as unknown as z.Schema<Note>

export const noteInitializer = z.object({
  id: noteId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: userId.optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: userId.optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: userId.optional().nullable(),
  message: z.string().optional().nullable(),
}) as unknown as z.Schema<NoteInitializer>

export const noteMutator = z.object({
  id: noteId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: userId.optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: userId.optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: userId.optional().nullable(),
  message: z.string().optional().nullable(),
}) as unknown as z.Schema<NoteMutator>
